import { makeHttpRequest } from "@/shared";

export const deleteSellings = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/delete-multiple`,
            method: "DELETE",
            params: {
                items: ids,
            },
        })
    ).data;

    return response;
};
